export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f7649e08d3cbcaeb7c6621a05d6c26ec01ed37b12&name=fetchTypeahead!'